import {  PropertyComponentGroup } from '../../plans/shared/models';
export type SaveState = 'saved' | 'failed' | 'inProgress' | 'notInit';

export interface SetupState {
  anticipatedExpenditures: PropertyComponentGroup;
  setupSaved: SaveState;
}

export interface State extends SetupState {
  isLoading?: boolean;
  error?: any;
}

export const initialState: State = {
  anticipatedExpenditures: null,
  setupSaved: 'notInit',
  isLoading: false,
  error: null
};

export const getAnticipatedExpenditures = (state: SetupState) => state.anticipatedExpenditures;
export const getSetupSaved = (state: SetupState) => state.setupSaved;
